/**
 * F4 — „Új verzió elérhető" prompt
 * A VitePWA registerType:'prompt' módhoz — a useRegisterSW hook jelzi az új SW-t.
 */
import { useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export default function AppUpdatePrompt() {
  const [updating, setUpdating] = useState(false);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      if (r) console.log('[PWA] Service worker regisztrálva');
    },
    onRegisterError(e) {
      console.error('[PWA] SW regisztrációs hiba:', e);
    },
  });

  if (!needRefresh) return null;

  return (
    <>
      <style>{`
        @keyframes _spin { to { transform: rotate(360deg); } }
        ._spin { animation: _spin .7s linear infinite; display: inline-block; }
      `}</style>
      <div
        role="alert"
        aria-live="polite"
        style={{
          position: 'fixed',
          bottom: '24px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'var(--navy)',
          color: '#fff',
          padding: '12px 18px',
          borderRadius: '12px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          zIndex: 9999,
          fontSize: '13px',
          fontWeight: 500,
          whiteSpace: 'nowrap',
        }}
      >
        <span>Új verzió érhető el.</span>
        <button
          onClick={() => { setUpdating(true); updateServiceWorker(true); }}
          disabled={updating}
          style={{
            background: 'var(--orange)',
            color: '#fff',
            border: 'none',
            borderRadius: '7px',
            padding: '6px 12px',
            fontSize: '12px',
            fontWeight: 700,
            cursor: updating ? 'default' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            opacity: updating ? 0.85 : 1,
          }}
        >
          {updating
            ? <><span className="_spin">↻</span> Frissítés...</>
            : 'Frissítés'}
        </button>
        {!updating && (
          <button
            onClick={() => setNeedRefresh(false)}
            aria-label="Bezárás"
            style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', padding: '2px 4px', fontSize: '16px' }}
          >
            ×
          </button>
        )}
      </div>
    </>
  );
}
